export const logoutSuccessFull = "Logout successful.";
export const SigninSuccessFull = "Sign in successfully.";
export const moduleSelected = "A Module has been selected.";
export const cart_clear_success_message =
  "Your cart has been cleared successfully. And selected item added to the cart.";
export const cart_clear_header = "Are you sure, you want to reset?";
export const cart_clear_description =
  "You have item from another store in cart. If you continue, your all previous item from cart will be removed and this one will be added.";
export const update_error_text = "No changes found to update.";
export const product_update_to_cart_message = "Updated successfully.";
export const not_logged_in_message = "You are not logged in";
export const message_sending_image_limit =
  "Maximum 3 images can be send at a time.";
export const loginSuccessFull = "Logged in successfully";
export const signup_successfull = "Signup successfully.";
export const cod_exceeds_message =
  "The total amount of the order, exceeds maximum amount of the cash on delivery method";
//module select popover
export const module_header = "Select a type of module for your orders";
export const module_bottom = "A module must be selected to continue.";
export const module_select_success = "A module has been selected.";
export const prescription_image_error_text =
  "Please upload your prescription image";
export const out_of_stock = "Out of Stock";
export const coupon_minimum =
  "To apply this coupon, total item amount should be minimum";
export const wallet_transfer_message = "Point to wallet transfer successfully.";
export const out_of_limits = "Out of Limits";
export const cart_item_remove = "Cart item remove successfully";
export const edit_offline_payment_info = "Payment info updated."
